// extracted by mini-css-extract-plugin
export default {"Chip":"ClusterTypeChip_Chip__mPGOW","BgName":"ClusterTypeChip_BgName__dUSV5","Label":"ClusterTypeChip_Label__puJ32","Compact":"ClusterTypeChip_Compact__ZPDBt"};